// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 991px) {
  .navbar-collapse {
    background: white !important;
    padding: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HorizontalLayout/navbar.css"],"names":[],"mappings":"AAAA;EACE;IACE,4BAA4B;IAC5B,aAAa;EACf;AACF","sourcesContent":["@media (max-width: 991px) {\r\n  .navbar-collapse {\r\n    background: white !important;\r\n    padding: 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
